module.exports = __webpack_public_path__ + "static/favicon-96x96-86a2c4f8c8ca0e4d4487de701730ecc6.png";